import api from "./api"

export const getOrganizations = async () => {
  const response = await api.get("/organizations")
  return response.data
}

export const getOrganizationFormData = async () => {
  const response = await api.get("/organizations/form-data")
  return response.data
}

export const getOrganizationById = async (organizationId) => {
  const response = await api.get(`/organizations/${organizationId}`)
  return response.data
}

export const createOrganization = async (payload) => {
  const response = await api.post("/organizations", payload)
  return response.data
}

export const updateOrganization = async (organizationId, payload) => {
  const response = await api.put(`/organizations/${organizationId}`, payload)
  return response.data
}

export const deleteOrganization = async (organizationId) => {
  const response = await api.delete(`/organizations/${organizationId}`)
  return response.data
}